/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FboLocationGroupRequestDto } from '../../models/fbo-location-group-request-dto';
import { FboLocationGroupResponse } from '../../models/fbo-location-group-response';

export interface UpdateFboLocationGroup$Params {

/**
 * The ID of the FBO location group to update.
 */
  id: number;
      body: FboLocationGroupRequestDto
}

export function updateFboLocationGroup(http: HttpClient, rootUrl: string, params: UpdateFboLocationGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<FboLocationGroupResponse>> {
  const rb = new RequestBuilder(rootUrl, updateFboLocationGroup.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FboLocationGroupResponse>;
    })
  );
}

updateFboLocationGroup.PATH = '/api/administration/fbo-locations-groups/{id}';
